export const Status = {
  CONFIRMADA: 1,
  PENDENTE: 0,
  CANCELADA: -1
};

export default {
  Status
};



// WEBPACK FOOTER //
// ./src/modules/reserva/constants.js